import { getRequestCache } from '@gef-ui/middleware-api/redux/cache/selectors';
import { makeGetRequestState } from '@gef-ui/middleware-api/redux/status/selectors';
import compose from "ramda/es/compose";
import fromPairs from "ramda/es/fromPairs";
import identity from "ramda/es/identity";
import map from "ramda/es/map";
import o from "ramda/es/o";
import prop from "ramda/es/prop";
import split from "ramda/es/split";
import when from "ramda/es/when";
import isString from "ramda-extension/es/isString";
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadMultipleVersions } from '../actions';
import { extractVersionResults } from '../utils';
const parseFeRespToJson = when(isString, compose(fromPairs, map(split('=')), split('\n')));
const defaultBeEndpointMappingArray = [
    {
        name: 'BE',
        endpoint: '/application/build-info'
    }
];
const defaultFeEndpointMappingArray = [
    {
        name: 'FE',
        endpoint: '/static/version.txt'
    }
];
export const useVersionInfoQuery = ({ endpointMappingArray = [], parseResponse, skipOauth, baseUrlSelector })=>{
    const dispatch = useDispatch();
    const requestCache = useSelector(getRequestCache);
    const getRequestState = useMemo(makeGetRequestState, []);
    const results = extractVersionResults(endpointMappingArray, requestCache, parseResponse);
    const requestStates = useSelector((state)=>endpointMappingArray.map(({ name })=>({
                name,
                ...getRequestState(state, name)
            })));
    useEffect(()=>{
        if (results?.length !== endpointMappingArray.length && !requestStates.every(({ isLoading })=>isLoading)) {
            const versionsToLoad = requestStates.filter(({ isLoading, isSuccess, isError })=>!isLoading && !isSuccess && !isError);
            dispatch(loadMultipleVersions(endpointMappingArray.filter(({ name })=>versionsToLoad.find((version)=>version.name === name)), skipOauth, baseUrlSelector));
        }
    }, [
        endpointMappingArray,
        dispatch,
        skipOauth,
        baseUrlSelector,
        results,
        requestStates
    ]);
    return results;
};
export const useFeVersionInfoQuery = ({ feEndpointMappingArray = defaultFeEndpointMappingArray, parseFeResponse = prop('app.version') })=>useVersionInfoQuery({
        endpointMappingArray: feEndpointMappingArray,
        skipOauth: true,
        parseResponse: o(parseFeResponse, parseFeRespToJson),
        baseUrlSelector: identity
    });
export const useBeVersionInfoQuery = ({ skipBeOauth = false, beEndpointMappingArray = defaultBeEndpointMappingArray, parseBeResponse = prop('version') })=>useVersionInfoQuery({
        endpointMappingArray: beEndpointMappingArray,
        skipOauth: skipBeOauth,
        parseResponse: parseBeResponse
    });
export default {
    versionInfo: {
        useBeVersionInfoQuery,
        useFeVersionInfoQuery
    }
};
